import FetchExtension from '@/core/extensions/FetchExtension';
// service 
import OdataReadOnlyServiceBase from '@/core/services/OdataReadOnlyServiceBase';
// interface
import TFetchExtension from '@/core/types/TFetchExtension';
import { IOdataPostRequest } from '@/core/types/TPostRequest';
import { IOdataDeleteRequest } from '@/core/types/TDeleteRequest';
// enum
import HttpMethodEnum from '@/core/enums/EHttpMethod';
import EndpointProtocol from '@/core/enums/EEndpointProtocol';


class OdataServiceBase extends OdataReadOnlyServiceBase {

	async post ( params: IOdataPostRequest ): Promise<any> {

		const apiFetchConfig: TFetchExtension = {
            // protocol: EndpointProtocol.ODATA,
			method: HttpMethodEnum.POST,
			language: params.language,

			sourcePath: this.sourcePath,
			body: params.body,
		}

		return FetchExtension(apiFetchConfig);

	}

}

export default OdataServiceBase;
